/*!
 * dasoertliche-javascript-library-7.26
 * 
 * Copyright (C) 2008-2025 TENSQUARE GmbH. All rights reserved.
 * https://www.tensquare.de
 * Die Inhalte dieser Datei sind urheberrechtlich geschützt. Sie dürfen
 * weder ganz noch in Teilen vervielfältigt, verbreitet oder öffentlich
 * zugänglich gemacht werden. Jegliche Nutzung, sowohl zu privaten als
 * auch zu kommerziellen Zwecken, bedarf der schriftlichen Genehmigung
 * der TENSQUARE GmbH.
 */
if (!$oe$ || !$ || !$oe$.ui) {
    throw new Error("Core libs missing");
}

(function(global, win, doc) {
    var namespace = global.getNamespace("sidebar");
    function SidebarHandler(opts) {
        var self = this, DEFAULT_OPTIONS = {
            selector: {
                maskedLink64: ".hitlist_leftside span[data-ml64]",
                filterSet: ".filterset",
                more: ".more",
                moreCities: "#morecities"
            },
            cls: {
                visible: "togone",
                invisible: "gone",
                filtersetGone: "filterset gone",
                switch: "switch"
            },
            dataAttribute: {
                maskedLink64: "ml64",
                wipeActionName: "waName"
            },
            wipe: {
                analyzer: undefined,
                enabled: true
            },
            onClickMore: undefined,
            urlBase: "https://www.dasoertliche.de"
        }, options, selector, cssClass, maskedLinkHandler;
        function init() {
            options = global.obj.deepMerge(DEFAULT_OPTIONS, opts || {});
            selector = options.selector;
            cssClass = options.cls;
            maskedLinkHandler = new global.seo.MaskedLinkHandler(options);
        }
        function toggleMoreLink(moreElm) {
            $(moreElm).find("a").each(function(idx, item) {
                item = $(item);
                if (item.hasClass(cssClass.switch)) {
                    return;
                }
                if (item.not("." + cssClass.invisible) && item.not("." + cssClass.visible)) {
                    item.toggleClass(cssClass.invisible);
                    return;
                }
                if (item.hasClass(cssClass.visible) || item.hasClass(cssClass.invisible)) {
                    item.toggleClass(cssClass.visible + " " + cssClass.invisible, false);
                }
            });
        }
        function onClickMoreLink(event) {
            if (global.val.isFunction(options.onClickMore)) {
                options.onClickMore.call(self, this, event);
            }
            var items = $(this).parent().find("li." + cssClass.invisible);
            if (items.length > 0) {
                items.toggleClass(cssClass.invisible, false);
                items.toggleClass(cssClass.visible);
                toggleMoreLink(this);
            } else {
                items = $(this).parent().find("li." + cssClass.visible);
                if (items.length > 0) {
                    items.toggleClass(cssClass.visible, false);
                    items.toggleClass(cssClass.invisible);
                    toggleMoreLink(this);
                }
            }
            return false;
        }
        function bindMoreLinksEvents() {
            var $filterSets, $filterSet, more;
            $filterSets = $(selector.filterSet);
            for (var i = 0; i < $filterSets.length; i++) {
                $filterSet = $($filterSets[i]);
                if ($filterSet.attr("class") === cssClass.filtersetGone) {
                    more = $(selector.moreCities).on("click", {
                        filterset: $filterSet
                    }, function(event) {
                        event.data.filterset.toggleClass(cssClass.invisible);
                        return false;
                    });
                    continue;
                }
                more = $filterSet.find(selector.more);
                if (more.length === 0) {
                    continue;
                }
                more = more[0];
                $(more).on("click", self, onClickMoreLink);
            }
        }
        function bindEvents() {
            bindMoreLinksEvents();
            maskedLinkHandler.bindEvents();
        }
        init();
        this.bindEvents = bindEvents;
    }
    namespace.SidebarHandler = SidebarHandler;
})($oe$, this, document);